module.exports = __webpack_public_path__ + "static/img/imgs2.88aed37.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/imgs2.png
// module id = 97BY
// module chunks = 1